import { render } from "./ClienteEdit.vue?vue&type=template&id=210c0e55"
import script from "./ClienteEdit.vue?vue&type=script&lang=js"
export * from "./ClienteEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__